<div class="aside aside-left d-flex flex-column" id="kt_aside">
  <div class="aside-brand d-flex flex-column align-items-center flex-column-auto py-3 py-lg-8 logo_bg">
    <a class="sidebar-logo" routerLink="/home" aria-label="Bhakts home">
      <img src="favicon.ico" alt="Bhakts">
    </a>
  </div>
  <div class="aside-nav d-flex overflow-auto flex-column align-items-center flex-column-fluid">
    <ul class="nav flex-column ">
      <li *ngFor="let option of menuOptions" [routerLink]="option.link"
          [ngClass]="{'active': isActive(option.activeURLs, activeUrl) , 'd-none' : !option.show}"
          class="nav-item"
          data-boundary="window"
          data-container="body"
          data-placement="right"
          data-toggle="tooltip"
          [title]="option.label">
        <a class="nav-link btn btn-icon btn-clean btn-icon-white btn-lg" >
          <i [class]="option.icon"></i><span>{{option.label}}</span></a>
      </li>
    </ul>
  </div>
</div>
